<!-- Responsibility: Display billing audit details and managed usage.
Scope: View-only card for billing and usage state. -->
<admin-billing-card>
  <section class="admin-card">
    <header>
      <h2>Billing & Usage</h2>
      <span class="admin-card-meta">Entitlements, managed quota burn, ownership receipts, and webhook audit drift.</span>
    </header>
    <ul class="admin-list compact">
      <li><strong>Plan</strong><span>{ props.commerce.planLabel }</span></li>
      <li><strong>Entitlement Source</strong><span>{ props.commerce.entitlementSource }</span></li>
      <li><strong>Managed Actions</strong><span>{ props.commerce.managedActionUsed } used · { props.commerce.managedActionRemaining } left</span></li>
      <li><strong>Managed Images</strong><span>{ props.commerce.managedImageUsed } used · { props.commerce.managedImageRemaining } left</span></li>
      <li><strong>Owned Receipts</strong><span>{ props.commerce.receiptCount }</span></li>
      <li><strong>Billing Events</strong><span>{ props.billingAudit.processedCount } processed · { props.billingAudit.ignoredCount } ignored</span></li>
      <li><strong>Plan Drift</strong><span>{ props.billingAudit.planDriftCount }</span></li>
      <li><strong>Customer Maps</strong><span>{ props.billingAudit.customerMapCount }</span></li>
    </ul>
    <ul if={ props.billingAudit.events.length } class="admin-roster">
      <li each={ event in props.billingAudit.events.slice(0, 4) }>
        <div class="admin-roster-copy">
          <strong>{ event.type || 'unknown_event' }</strong>
          <span>{ event.uid || 'no uid' } · { event.plan || 'no plan' } · { event.status || 'unknown' }</span>
        </div>
        <div class="admin-roster-meta">
          <small>{ event.claimsChanged ? 'Claims changed' : 'Claims unchanged' }</small>
          <small>{ event.processedAtMs ? props.formatTime(event.processedAtMs) : 'No processed timestamp' }</small>
        </div>
      </li>
    </ul>
    <p if={ !props.billingAudit.events.length } class="admin-copy">No billing audit events are available in the current runtime.</p>
  </section>

  <style>
    .admin-card {
      display: grid;
      gap: var(--space-sm);
      border: 1px solid color-mix(in srgb, var(--border) 46%, transparent);
      border-radius: 1rem;
      padding: var(--space-md);
      background: var(--surface-raised);
      box-shadow: var(--shadow-elev-2);
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: var(--space-sm);
    }

    h2 {
      margin: 0;
      color: var(--text-prose);
    }

    .admin-card-meta {
      font-size: var(--type-xs);
      color: var(--text-muted);
    }

    .admin-copy {
      color: var(--text-muted);
      font-size: var(--type-sm);
      margin: 0;
    }

    .admin-list.compact {
      display: grid;
      gap: 0.25rem;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .admin-list.compact li {
      display: flex;
      justify-content: space-between;
      font-size: var(--type-sm);
    }

    .admin-roster {
      display: grid;
      gap: var(--space-xs);
      margin: var(--space-sm) 0 0 0;
      padding: 0;
      list-style: none;
    }

    .admin-roster li {
      padding: var(--space-xs);
      border: 1px solid var(--border);
      border-radius: 0.25rem;
      font-size: var(--type-xs);
    }
  </style>
</admin-billing-card>
